import {
	Button,
	Dialog,
	DialogContent,
	IconButton,
	MenuItem,
	Paper,
	Select,
	Slide,
	TextField,
	Toolbar,
	Typography,
	createTheme,
	useMediaQuery,
} from "@mui/material"
import { forwardRef, useContext, useEffect, useState } from "react"
import CloseIcon from "@mui/icons-material/Close"
import { adminGetWhatsAppTemplates, adminSendWhatsApp } from "../util/firebase"
import { AdminContext } from "../views/Admin"

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />
})

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
})

const SendWhatsAppDialog = ({ sendWhatsAppOpen, setSendWhatsAppOpen }) => {
	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))

	const adminContext = useContext(AdminContext)
	const handleOpenSnackbar = adminContext.handleOpenSnackbar

	const [templatesList, setTemplatesList] = useState([])
	const [templateId, setTemplateId] = useState("")
	const [parameters, setParameters] = useState([])
	const [parameterValues, setParameterValues] = useState([])
	const [text, setText] = useState("")
	const [phoneNumber, setPhoneNumber] = useState("")

	useEffect(() => {
		const _adminGetWhatsAppTemplates = async () => {
			const response = await adminGetWhatsAppTemplates()
			if (response.data.status === 0) {
				setTemplatesList(response.data.templates)
			}
		}
		_adminGetWhatsAppTemplates()
	}, [])

	useEffect(() => {
		/* parameters.forEach((p) => {
			setParameterValues((prevState) => [...prevState, ""])
		}) */
		setParameterValues(Array(parameters.length).fill(""))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [parameters])

	const handleClose = async () => {
		const payLoad = { templateId: templateId, parameterValues: parameterValues, phoneNumber: phoneNumber }
		try {
			const response = await adminSendWhatsApp({
				templateId: templateId,
				parameterValues: parameterValues,
				phoneNumber: phoneNumber,
			})
			if (response.data.status === 0) {
				handleOpenSnackbar("הודעת וואטסאפ נשלחה בהצלחה!", "success")
			} else {
				handleOpenSnackbar("תקלה בשליחת וואטסאפ", "error")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בשליחת וואטסאפ", "error")
		}
		console.log(payLoad)
	}

	return (
		<Dialog
			fullScreen={!matches}
			open={sendWhatsAppOpen}
			onClose={() => {
				setSendWhatsAppOpen(false)
				setTemplateId("")
				setParameters([])
				setParameterValues([])
				setText("")
				setPhoneNumber("")
			}}
			TransitionComponent={Transition}
			PaperProps={{
				style: {
					backgroundColor: "white",
					maxHeight: "715px",
				},
			}}
			maxWidth={"md"}
			/* scroll="body" */
			/* sx={{ maxHeight: "715px"}} */
		>
			<Toolbar>
				<IconButton
					edge="start"
					color="inherit"
					onClick={() => {
						setSendWhatsAppOpen(false)
						setTemplateId("")
						setParameters([])
						setParameterValues([])
						setText("")
						setPhoneNumber("")
					}}
					aria-label="close"
				>
					<CloseIcon />
				</IconButton>
				<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
					שליחת וואטסאפ
				</Typography>
			</Toolbar>
			<DialogContent dividers>
				<Paper
					sx={{
						p: 2,
						display: "flex",
						flexDirection: "column",
						justifyContent: "flex-start",
						flexWrap: "wrap",
					}}
				>
					<Select
						value={templateId}
						/* label="חודש" */
						size="small"
						sx={{ width: "100%" }}
						onChange={(e) => {
							setTemplateId(e.target.value)
							const _template = templatesList.find((template) => template.templateId === e.target.value)
							console.log(_template.parameters)
							setParameters(_template.parameters)
							setText(_template.text)
						}}
					>
						{templatesList.map((e) => (
							<MenuItem key={e.templateId} value={e.templateId}>
								{e.templateName}
							</MenuItem>
						))}
					</Select>
					<Typography
						sx={{ ml: 2, flex: 1, mt: 2 }}
						variant="h7"
						component="div"
						dangerouslySetInnerHTML={{ __html: text.replaceAll("\r\n", "<br/>") }}
					/>
					<Typography sx={{ ml: 2, flex: 1, mt: 2 }} variant="h7" component="div">
						פרמטרים
					</Typography>
					{parameterValues.map((parameterValue, index) => (
						<TextField
							key={index}
							/* label={"יד"} */
							value={parameterValue}
							onChange={(e) => {
								setParameterValues((prevState) => {
									const newState = [...prevState]
									newState[index] = e.target.value
									return newState
								})
							}}
							size="small"
							sx={{
								mt: 0,
								ml: 1,
								mr: 1,
								mb: 1,
								maxHeight: "36px",
								input: { background: "white" } /* maxWidth: "40px" */,
							}}
							placeholder={parameters[index]}
						/>
					))}
					<Typography sx={{ ml: 2, flex: 1, mt: 2 }} variant="h7" component="div">
						טלפון
					</Typography>
					<TextField
						/* label={"יד"} */
						value={phoneNumber}
						onChange={(e) => {
							setPhoneNumber(e.target.value)
						}}
						size="small"
						sx={{
							mt: 0,
							ml: 1,
							mr: 1,
							mb: 1,
							maxHeight: "36px",
							input: { background: "white" } /* maxWidth: "40px" */,
						}}
					/>
				</Paper>
				<Button
					sx={{ backgroundColor: mdTheme.palette.primary.main, width: matches ? "120px" : "auto", mt: 2, mb: 2 }}
					onClick={() => handleClose()}
					variant="contained"
				>
					שליחה
				</Button>
			</DialogContent>
		</Dialog>
	)
}

export default SendWhatsAppDialog
